import React from 'react';

import PropTypes from 'prop-types';

import StatusView from '@vfgroup-oneplatform/foundation/Components/StatusView';
import { getThemeImages, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import Description from '../Description/Description';

import styles from './Failure.style';

const Failure = ({
  onTryAgainPress,
  closeQAM,
  title,
  primaryButtonProps,
  secondaryButtonProps,
  ...rest
}) => {
  const theme = useTheme();
  const foundationImages = getThemeImages(theme.name);

  return (
    <StatusView
      image={foundationImages.ic_warning_red}
      title={title}
      renderDescription={() => <Description {...rest} />}
      containerStyle={styles.failureViewContainer}
      textStyles={{
        textContainer: styles.failureTextContainer,
        title: styles.titleStyle,
      }}
      {...(primaryButtonProps && {
        primaryButtonProps: { ...primaryButtonProps, onPress: onTryAgainPress },
      })}
      {...(secondaryButtonProps && {
        secondaryButtonProps: {
          ...secondaryButtonProps,
          onPress: closeQAM,
          style: styles.secondaryButton,
        },
      })}
    />
  );
};

Failure.propTypes = {
  onTryAgainPress: PropTypes.func,
  closeQAM: PropTypes.func,
  title: PropTypes.string.isRequired,
  primaryButtonProps: PropTypes.shape({
    title: PropTypes.string,
    onPress: PropTypes.func,
    type: PropTypes.string,
  }),
  secondaryButtonProps: PropTypes.shape({
    title: PropTypes.string,
    onPress: PropTypes.func,
    type: PropTypes.string,
  }),
};
export default Failure;
